import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="cta-section">
      <Container>
        <div className="cta-box fade-up">
          <h2>Grow Smarter. Farm Better.</h2>
          <p>
            Join hands with Hindustan Agro Life and experience safe, reliable,
            and eco-friendly agricultural solutions designed for Indian farming.
          </p>

          <div className="cta-buttons">
            <Link to="/contact" className="cta-btn primary">
              Contact Us
            </Link>

            <Link to="/products" className="cta-btn secondary">
              View Products
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CTASection;
